import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11294acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled", "loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "OkButton",
    type: _ctx.type,
    disabled: _ctx.disabled,
    loading: _ctx.loading,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode("Загрузка...")
        ], 64))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ], 8, _hoisted_1))
}